export default {
  infoToggle: "Ver ayuda y ejemplos de temas",
  maxWarning:
    "Alcanzaste el máximo de {max} caracteres para el tema. Recuerda que bastan palabras clave breves.",
};
